import React from "react"
import styled, { css } from "styled-components"
import SwiperCore, { Pagination, Navigation, Autoplay } from "swiper"
import { Swiper, SwiperSlide } from "swiper/react"
import HeroResolver from "../../../resolvers/hero/hero.resolver"
import { AppFunctionComponent, HeroBuilder } from "../../../types"
import "swiper/swiper-bundle.min.css"
import { ArrowIcon } from "../slider.component"
import { ScrollAnchor } from "../sections/custom/innovation-lab-form/innovation-lab.component"
import { HeroImage } from "../sections/hero-section-refactored.component"
import { useLocation } from "@reach/router"

export const ArrowContainer = styled.div<{
  active: boolean
}>`
  top: 50%;
  opacity: 1;
  width: 42px;
  height: 42px;
  display: flex;
  display: none;
  cursor: pointer;
  position: absolute;
  border-radius: 50%;
  align-items: center;
  flex-direction: row;
  pointer-events: all;
  visibility: visible;
  user-selectable: none;
  justify-content: center;
  transform: translateY(-50%);
  background-color: ${({ theme }) => theme.color.arrowBackgroundDark};
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
  z-index: 1000;

  &.swiper-button-disabled {
    display: none;
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    display: none;
  }

  ${({ active }) =>
    !active &&
    css`
      opacity: 0;
      visibility: hidden;
    `};
`

export const ArrowPrev = styled(ArrowContainer)`
  left: 5%;

  svg {
    transform: rotateZ(180deg);
  }
`

export const ArrowNext = styled(ArrowContainer)`
  right: 5%;
`

const SwiperWrapper = styled(Swiper)`
  width: 100%;

  ${HeroImage} {
    z-index: -1 !important;
  }

  .swiper-pagination-bullets {
    bottom: 30px !important;
    @media (max-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
      top: 90vw !important;
      bottom: unset !important;
    }
  }

  .swiper-pagination-bullet {
    width: 15.258px;
    height: 15.258px;
    border-radius: 50%;
    margin: 0 4px;
    cursor: pointer;
    background-color: #414040;
    opacity: 1;
    &:hover {
      background-color: white;
    }
  }

  .swiper-pagination-bullet-active {
    background-color: white;
  }
`

// const NewsletterPopupButtonWrapper = styled.div`
//   position: absolute;
//   left: 0;
//   right: 0;
//   top: 0;
//   bottom: 0;
//   width: 100%;
//   height: 100%;
//   max-width: 1920px;
//   margin: 0 auto;
// `

// const NewsletterPopupButton = styled.div`
//   position: absolute;
//   bottom: 60px;
//   right: 60px;
//   width: 222px;
//   height: 72px;
//   z-index: 1000;
//   border-radius: 8px;
//   background: #e7eaea;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   gap: 10px;
//   z-index: 1000;
//   padding: 0 24px;
//   cursor: pointer;

//   @media (max-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
//     top: 22px;
//     right: 20px;
//     left: 20px;
//     width: unset;
//     height: 40px;
//   }
// `

// const NewsletterPopupButtonText = styled.p`
//   color: #000;
//   font-family: Montserrat;
//   font-size: 16px;
//   font-style: normal;
//   font-weight: 500;
//   line-height: 150%;

//   @media (max-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
//     font-size: 11px;
//     font-weight: 600;
//   }
// `

// const NewsletterPopupButtonClose = styled.div`
//   width: 24px;
//   height: 24px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   font-size: 16px;
//   font-weight: 600;
//   color: #000;
//   cursor: pointer;
// `

interface Props {
  slides: HeroBuilder[]
  anchorId?: string
}

SwiperCore.use([Pagination, Navigation, Autoplay])

const HeroCarousel: AppFunctionComponent<Props> = ({ slides, anchorId }) => {
  const location = useLocation()

  const pagination = {
    clickable: true,
  }
  const autoplay = {
    delay: 5000,
  }

  return (
    <>
      <SwiperWrapper
        threshold={60}
        pagination={pagination}
        navigation={{
          nextEl: ".swiper-arrow-right",
          prevEl: ".swiper-arrow-left",
        }}
        data-testid="hero-carousel"
        autoplay={autoplay}
      >
        <ScrollAnchor id={anchorId} />
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <HeroResolver {...slide} />
          </SwiperSlide>
        ))}
        <>
          <ArrowPrev className="swiper-arrow-left" active>
            <ArrowIcon />
          </ArrowPrev>
          <ArrowNext className="swiper-arrow-right" active>
            <ArrowIcon />
          </ArrowNext>
        </>
      </SwiperWrapper>
    </>
  )
}

export default HeroCarousel
